import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import FooterLink from '@/repositories/data/content/FooterLink';

export default class ContentPageRepository extends BaseCrudRepository<number, FooterLink, FooterLink> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/footer-link/');
    }
}
